<section>
  <div *ngIf="messages().length === 0" class="alert alert-info">
    No communications
  </div>

  <div *ngIf="messages().length > 0" #timelineRef class="message-timeline">
    <div *ngFor="let message of messages(); trackBy: trackByMessageId"
         class="message-row"
         [class.outbound]="isNotification(message)"
         [class.inbound]="isInbound(message)">
      <div class="message-bubble">
        <p class="message-content" data-dd-privacy="mask">{{ getMessageContent(message) }}</p>
        <div class="message-footer">
          <shared-badge [class]="getTypeBadgeClass(message)" [label]="getMessageType(message)"></shared-badge>
          <shared-badge [class]="getStatusBadgeClass(message)" [label]="getStatusLabel(message)"></shared-badge>
          <span class="message-time">{{ message.time | trDateFormat:'M/D/yy h:mm a': timezone() }}</span>
        </div>
        <small *ngIf="getFailureReason(message) as reason" class="failure-reason d-block">{{ reason }}</small>
      </div>
    </div>
  </div>

</section>
